import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Card from '../../shared/components/UIElements/Card';

import Modal from '../../shared/components/UIElements/Modal';

import { AuthContext } from '../../shared/context/auth-context';

import './UserProfile.css';

// import footer
//import Footer from '../../shared/components/UIElements/Footer';

const UserProfile = () => {

    const auth = useContext(AuthContext);

    //const userId = useParams().userId;
    const { userId } = useParams();

    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const [showContactModal, setShowContactModal] = useState(false);

    const [showLoginModal, setShowLoginModal] = useState(false);

    const history = useHistory();

    /*
    const openContactHandler = () => {
        setShowContactModal(true);
    };
    */
    const openContactHandler = () => {
        if (!auth.isLoggedIn) {
            setShowLoginModal(true);
            return;
        }

        setShowContactModal(true);
    };



    const closeContactHandler = () => {
        setShowContactModal(false);
    };

    useEffect(() => {
        const fetchUserProfile = async () => {
            setIsLoading(true);

            try {
                const response = await fetch(
                    //`${process.env.REACT_APP_BACKEND_URL}/${userId}/profile`
                    //`http://localhost:5001/api/users/${userId}/profile`
                    //process.env.REACT_APP_BACKEND_URL + `/users/${userId}/profile`
                    `${process.env.REACT_APP_BACKEND_URL}/users/${userId}/profile`
                );

                const responseData = await response.json();

                if (!response.ok) {
                    throw new Error(
                        responseData.message || 'Failed to fetch profile.'
                    );
                }

                setUser(responseData.userregister);
            } catch (err) {
                setError(err.message || 'Something went wrong.');
            }

            setIsLoading(false);
        };

        fetchUserProfile();
    }, [userId]);


    if (isLoading) {
        return (
            <div className="center">
                <h2>Loading profile...</h2>
            </div>
        );
    }

    if (error) {
        return (
            <div className="center">
                <h2>{error}</h2>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="center">
                <h2>User profile not found.</h2>
            </div>
        );
    }

    //const history = useHistory();

    return (
        <React.Fragment>

            {/* MODAL */}
            <Modal
                show={showContactModal}
                onCancel={closeContactHandler}
                header="Contact Details"
                footer={
                    <button onClick={closeContactHandler}>
                        CLOSE
                    </button>
                }
            >
                <h2>Call: {user.mobile}</h2>
                <h2>Email: {user.email}</h2>
                {user.whatsAppNumber && (
                    <h2>WhatsApp: {user.whatsAppNumber}</h2>
                )}
            </Modal>

            <Modal
                show={showLoginModal}
                onCancel={() => setShowLoginModal(false)}
                header="Login Required"
                footer={
                    <button onClick={() => setShowLoginModal(false)}>
                        CLOSE
                    </button>
                }
            >
                <p>
                    Please create an account or log in to view contact details.{' '}
                    <Link to="/auth">Signup/Login</Link>
                </p>
            </Modal>



            <div className="user-item_profile">
                {/*</div><li className="user-item_profile">*/}
                <Card className="user-item__content">

                    <div className="user-item__layout_profile">

                        {/* LEFT */}
                        <div className="user-item__section personal-info">
                            {/*<h3>Personal Info</h3>*/}
                            <div className="profile-name">
                                <h3>{user.name}</h3>
                            </div>

                            {/*<h2>{user.id}</h2>*/}
                            {/*<h2>{user.name}</h2>*/}
                            <h2>{user.gender}</h2>
                            <h2>{user.city}</h2>
                            {/*<h2>{user.email}</h2>*/}
                            {/*<h2>{user.mobile}</h2>*/}
                            <h2>{user.highedu}</h2>
                            {user.preferredLanguage && (
                                <h2>{user.preferredLanguage}</h2>
                            )}
                        </div>

                        {/* RIGHT - Sandwich Style */}
                        <div className="user-item__right">

                            <div className="user-item__section interests">
                                <h3>Key Skills</h3>

                                <ul className="interest-list_interests">
                                    {user.interests
                                        ?.filter(interest => interest && interest.trim() !== "")
                                        .map((interest, index) => (
                                            <li key={index}>{interest}</li>
                                        ))}
                                </ul>
                            </div>
                            {/*
                            <div className="user-item__section interests">
                                <h3>Interests</h3>

                                {user.interests &&
                                    user.interests.map((interest, index) => (
                                        <h2 key={index}>{interest}</h2>
                                    ))}

                            </div>
                            */}
                            <div className="user-item__section services">
                                <h3>Services Offered</h3>

                                <ul className="service-list_services">
                                    {user.services
                                        ?.filter(service => service && service.trim() !== "")
                                        .map((service, index) => (
                                            <li key={index}>{service}</li>
                                        ))}
                                </ul>
                            </div>

                            {/*
                            <div className="user-item__section services">
                                <h3>Services</h3>

                                {user.services &&
                                    user.services.map((service, index) => (
                                        <h2 key={index}>{service}</h2>
                                    ))}
                            </div>
                            */}
                            <div className="user-item__section charges">
                                <h3>Charges</h3>

                                <ul className="charge-list">
                                    {user.rateCard?.consultation && (
                                        <li>Rs. {' '} {user.rateCard.consultation} Consultation charges</li>
                                    )}

                                    {user.rateCard?.solution1 && (
                                        <li>Rs. {' '} {user.rateCard.solution1} Solution charges</li>
                                    )}

                                    {user.rateCard?.solution2 && (
                                        <li>Rs. {' '} {user.rateCard.solution2} Monthly charges</li>
                                    )}
                                </ul>

                                {user.rateCard?.description && (
                                    <>
                                        <h3>Description</h3>
                                        <p className="charge-description">
                                            {user.rateCard.description}
                                        </p>
                                    </>
                                )}
                            </div>
                            {/*
                            <div className="user-item__section charges">
                                <h3>Charges</h3>

                                {user.rateCard?.consultation && (
                                    <h2>{user.rateCard.consultation}</h2>
                                )}

                                {user.rateCard?.solution1 && (
                                    <h2>{user.rateCard.solution1}</h2>
                                )}

                                {user.rateCard?.solution2 && (
                                    <h2>{user.rateCard.solution2}</h2>
                                )}

                                <h3>Description</h3>

                                {user.rateCard?.description && (
                                    <h2>{user.rateCard.description}</h2>
                                )}

                            </div>
                            */}
                        </div>
                    </div>

                </Card>
                {/*</li>*/}
                <div className="profile-btn-container">
                    {auth.isLoggedIn && auth.userId === user.userId && (
                        <button className="contact-btn_profile" onClick={() => history.push(`/${auth.userId}/register`)} >
                            Edit
                        </button>
                    )}
                    {auth.userId !== user.userId && (
                        <button className="contact-btn_profile" onClick={openContactHandler}>
                            Contact
                        </button>
                    )}
                    {/*
                    <button className="contact-btn_profile" onClick={openContactHandler}>
                        Contact
                    </button>*/}
                </div>
            </div>
            {/* Footer */}
            {/*
            <Footer />
            */}
        </React.Fragment>
    );
};

export default UserProfile;